import { ChevronDown } from "react-bootstrap-icons";

export const ActionButton = () => {
  return (
    <button className="settings__action-button" type="button">
      Действия <ChevronDown />
    </button>
  );
};
